import React, { useState, createContext, useContext } from 'react';
interface User {
  id: string;
  name: string;
  email: string;
  role: 'admin' | 'broker' | 'compliance';
}
interface AuthContextType {
  user: User | null;
  login: (email: string, password: string) => Promise<boolean>;
  logout: () => void;
  isAuthenticated: boolean;
}
const AuthContext = createContext<AuthContextType | undefined>(undefined);
export function AuthProvider({
  children
}: {
  children: ReactNode;
}) {
  const [user, setUser] = useState<User | null>(null);
  const login = async (email: string, password: string): Promise<boolean> => {
    // Simulate API call
    if (email && password) {
      // Mock user data based on email
      let role: 'admin' | 'broker' | 'compliance' = 'broker';
      if (email.includes('admin')) {
        role = 'admin';
      } else if (email.includes('compliance')) {
        role = 'compliance';
      }
      setUser({
        id: 'user-1',
        name: email.split('@')[0],
        email,
        role
      });
      return true;
    }
    return false;
  };
  const logout = () => {
    setUser(null);
  };
  return <AuthContext.Provider value={{
    user,
    login,
    logout,
    isAuthenticated: !!user
  }} data-id="element-715">
      {children}
    </AuthContext.Provider>;
}
export function useAuth() {
  const context = useContext(AuthContext);
  if (context === undefined) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
}